import React, { useCallback, useState } from "react";
import { Button, View, Switch } from "react-native";
import LoadingBoundary from "../../ui_atoms/LoadingBoundary";
import Text from "../../components/Text";
import type { Meta, StoryObj } from "@storybook/react";

function LoadingBoundaryStoryComponent() {
    const [error, setError] = useState<Error | null>(null);
    const [loading, setLoading] = useState(false);

    const spamError = useCallback(() => {
        setError(new Error("This is a simple error"));
    }, []);
    return (
        <View style={{ alignSelf: "stretch" }}>
            <View
                style={{
                    alignSelf: "center",
                    borderWidth: 1,
                    borderRadius: 10,
                    padding: 10,
                    marginBottom: 20,
                }}
            >
                <Button title={"Spam error"} onPress={spamError} />
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text>Loading :</Text>
                    <Switch onValueChange={setLoading} value={loading} />
                </View>
            </View>
            <View style={{ alignSelf: "stretch", backgroundColor: "white", padding: 10, flex: 0 }}>
                <LoadingBoundary
                    loading={loading}
                    error={error}
                    clearError={() => void setError(null)}
                >
                    <Text style={{ alignSelf: "center", fontSize: 30 }}>This is the content</Text>
                </LoadingBoundary>
            </View>
        </View>
    );
}

const meta = {
    title: "Atom/LoadingBoundary",
    component: LoadingBoundaryStoryComponent,
    argTypes: {},
} satisfies Meta<typeof LoadingBoundaryStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
